import { CODE } from 'domains/product-attribute/constants'
import ProductAttributeInputSelectField from 'domains/product-attribute/molecules/input-select-field'
import ProductAttributeMultiSelectField from 'domains/product-attribute/molecules/multiselect-field'
import ProductAttributeSelectSearchField from 'domains/product-attribute/molecules/select-search-field'
import PropTypes from 'prop-types'
import React from 'react'


const propTypes = {
  code                  : PropTypes.string,
  name                  : PropTypes.string,
  label                 : PropTypes.string,
  required              : PropTypes.bool,
  allow_multiple_values : PropTypes.bool
}

/**
 * Render only field for Product Attribute that has reference table.
 * i.e **Color**, **Material**, **Fabric**
 * This component only used for `ProductAttributeDynamicForm`
 * @param {string} code - Product Attribute code
 * @param {string} label - Product Attribute label
 * @param {bool} required - Product Attribute curation field required
 * @param {bool} allow_multiple_values - Product Attribute allow multiple values
 */
const ScraperProductAttributeHasReferenceTableFields = ({
  code,
  name,
  label,
  required,
  allow_multiple_values
}) => {

  if (allow_multiple_values) {
    return (
      <ProductAttributeMultiSelectField
        key={ `${code}-attribute-dynamic-multi-select-field` }
        code={ code }
        name={ name || code }
        label={ label }
        required={ required }
        isCuration={ true }
      />
    )
  }
  else {

    // * Only specific for brand or attribute with many options (brand has +/- 4500 option!).
    // * To solve performance issue.
    if (code === CODE.BRAND) {
      return (
        <ProductAttributeSelectSearchField
          key={ `${code}-attribute-dynamic-select-search-field` }
          code={ code }
          name={ name || code }
          label={ label }
          required={ required }
          isCuration={ true }
        />
      )
    }
    else {
      return (
        <ProductAttributeInputSelectField
          key={ `${code}-attribute-dynamic-input-select-field` }
          code={ code }
          name={ name || code }
          label={ label }
          required={ required }
          isCuration={ true }
        />
      )
    }
  }
}

ScraperProductAttributeHasReferenceTableFields.propTypes = propTypes

export default ScraperProductAttributeHasReferenceTableFields
